// Global Variables
let productOptions, productPrice, priceReduction, comparePrice, quantity, ppd, initBuyBox = false, varId, selectedProduct, purchaseOption;
var is_subscription;

// Initializes the Product Buy Box
function initProdBuyBox() {
  is_subscription = determineB2B() ? false : true;
  priceReduction = 0.05;
  quantity = $('.js-qty #Quantity').val();
  productOptions = $('.product-variant-selection');

  // Attach variant Ids to each product on the buybox
  if (($('.product-per-day-price').length) && ($('.product-variant-selection').length)) {
    varId = $('.product-variant-selection').find('div.variantId').attr('id');
    ppd = Number(($(`.price-container .variant-${varId}`).attr("ppd")).replace(/[^0-9\.-]+/g, ""));
  } else if($('.product-per-day-price').attr('ppd')) {
    ppd = Number(($('.product-per-day-price').attr('ppd')).replace(/[^0-9\.-]+/g, "")); 
  }

  productPricePerDay = $('.price-container .product-per-day-price');

  // Attach each product's ppd to the buy box
  productPricePerDay.each(function() {
    $(this).text("THAT'S ONLY \n " + $(this).attr("ppd") + " PER DAY");
  });

  prodBuyBoxListeners();
  determineLocation();
  updatePrice();
  changeButtonText(is_subscription);
  initBuyBox = true;
}

// Will convert floats, integers, and strings to a price (if a product has one)
function priceParse(elem, attr, pr) {
  let price; 

  // Find by attribute
  if($(elem).find(".variant__price").length && jQuery.type(attr) === 'string') {
    console.log("Price Parse: found attr!");
    price = $(elem).find(".variant__price").data(attr);
  } else if(jQuery.type(elem) === 'number') {
    // Find by integer type
    console.log("Price Parse: found Number!");
    price = '$' + elem;
  } else if(jQuery.type(elem) === 'string') {
    // Find by string type
    console.log("Price Parse: found String!");
    price = elem.replace(/[^0-9\.-]+/g, ""); 
  } else if(jQuery.type(elem) === 'null' || jQuery.type(elem) === 'undefined' || jQuery.type(elem) === 'function'|| isNaN(elem) === false) {
    // Determine if invalid price
    console.log("Price Parse: found Undefined!");
    price = 0.00;
  }

  if(pr) {
    price = ((Number(price.replace(/[^0-9\.-]+/g, ""))) - (Number(price.replace(/[^0-9\.-]+/g, "")) * pr));
    console.log(price)
  } else {
    price = Number(price.replace(/[^0-9\.-]+/g, "")); 
  }
  
  return ('$' + price.toFixed(2))
}

// Will contain all event listeners for the product buy box
function prodBuyBoxListeners(){
  $(document).ready(function(){
    $('.product-single__form').on('click', '.yotpo-radio-buy-once-container .yotpo-radio-label', function(){
      $('.yotpo-radio-label-input').attr('aria-checked', 'true');
    });

    $('#ProductSelect-option-0').on('click', ".product-variant-selection", function() {
      updatePrice();
      currSelectedProd = $(this);
    }).change(function(){
      updatePrice();
    })

    $(document).on('click', '.product-single__form .yotpo-radio-subscription-container .yotpo-radio-label-input', function(){
      is_subscription = true;
      updatePrice();
      purchaseOption = $(this);
    });

    $(document).on('click', '.product-single__form .yotpo-radio-buy-once-container .yotpo-radio-label-input', function(){
      is_subscription = false;
      updatePrice();
      purchaseOption = $(this);
    });
  
    // Product variant selector
    $('.product-variant-selection').click(function(){
      varId = $(this).find('div.variantId').attr('id');
      $('#ProductPrice2').attr("content", ($(this).find('.variant__price').attr('data-unit-price').replace(/[^0-9.-]+/g, "")))
    });

    $('#ProductSelect-option-0 input').first().prop('checked', true);
  })
}

// Will determine if the customer is a b2b customer.
function determineB2B() {
  return $('.b2b-customer').length !== 0 ? true : false;
}

// Adjust the product buy box according to the prices, discounts, subscription, and quantity.
function updatePrice() {
  // Will prevent users from leaving a "0" in the quantity selector.
  if(quantity == "0") quantity = $('.js-qty #Quantity').val(1);

  // Will determine if the variant selector is available, and change the PPD according to it.
  if($('#ProductSelect-option-0').length) {
    ppd = Number(($(`.price-container .variant-${varId}`).attr("ppd")).replace(/[^0-9\.-]+/g, "")); 
  } else if($('.product-per-day-price').attr('ppd')){
    ppd = Number(($('.product-per-day-price').attr('ppd')).replace(/[^0-9\.-]+/g, "")); 
  }

  // Adjust product price according to purchase option selected
  is_subscription ? priceReduction = 0.05 : priceReduction = '';
  
  productPrice = priceParse($('#ProductPrice2').attr('content'), "unit-price", priceReduction);
  comparePrice = priceParse($('#ComparePrice').attr('content'), "compare-price");
  $('#ComparePrice').text(comparePrice);
  $('#ProductPrice2').text(productPrice);

  if(ppd) {
    $('.product-per-day-price').text("THAT'S ONLY \n $" + ((is_subscription && ppd ? (ppd - (ppd*priceReduction)).toFixed(2) : ppd.toFixed(2))) + " PER DAY");
  }

  // If product variants exist, then update their prices accordingly.
  if(productOptions) {
    updateVariantPrice(); 
  }

  changeButtonText(is_subscription);
} 

// Update variant prices when customers change purchase options
function updateVariantPrice() {
  $('.product-variant-selection .variant__price').each(function(i){
    $(this).text(priceParse(productOptions[i], 'unit-price', priceReduction));
  })
}

function changePrices(price, pr) {
  $('.product-variant-selection .variant__price').each(function(){
    $(this).text(price)
  })
}

// Determine if a product page requires a Proposition 65 Warning Text to be displayed.
function determineP65(region) {
  let pw = document.querySelectorAll('.product-warning'), pvs = document.querySelectorAll('.product-variant-selection');

  // Attach event listener to hide the P65 Warning when Jars are selected. (Pushed on Dev: 08/14/24 - @JoshuaW)
  if(region !== 'California') {
    pw.forEach(function(el){
      el.classList.add('hide');
    })
  }
  
  // Show P65 to Customers in California.
  region == 'California' ? pw.classList.remove('hide') : ''
}

function isNonContiguousUSA(country, region) {
  let isNonContiguous = false;
  
  if(country != 'US') {
    isNonContiguous = true;
  } else if(country === 'US') {
    if(region === 'Alaska' || region === 'Hawaii') {
      isNonContiguous = true;
    }
  }

  return isNonContiguous;
}

// Function to wrap jQuery.get in a Promise
function fetchIpInfo() {
  return new Promise((resolve, reject) => {
    jQuery.get("http://ipinfo.io", function(response) {
      resolve(response);
    }, "jsonp").fail(function(jqXHR, textStatus, errorThrown) {
      reject(new Error(`Request failed: ${textStatus}`));
    });
  });
}

// Helps determine the whether the button text will change according to the subscription.
function changeButtonText(option) {
  let atc_btn_text = $('.atc_btn .btn__text'),
      is_b2b = determineB2B(),
      sold_out = $('.atc_btn').attr("disabled");

  if(option === true && is_b2b !== true && sold_out !== 'disabled') {
    atc_btn_text.text('Set up Subscription')
  } else if (sold_out !== 'disabled') {
    atc_btn_text.text('Add to Cart')
  }
}

// An async call to determine the location of a customer.
async function determineLocation() {
try {
    const response = await fetchIpInfo();
    const { city, country, region } = response;
    
    if(isNonContiguousUSA(country, region)) {
      changePurchaseOption('buy-once');
    } else {
      determineP65(region);
    }
  } catch (error) {
    console.error('Error fetching location:', error);
  }
}

initProdBuyBox();
console.log("Buybox Product Script Loaded!!!")